import React, {useEffect, useState} from 'react';

import {
  Box,
  HStack,
  Heading,
  ScrollView,
  Text,
  VStack,
  Pressable,
} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {useSalesmanContext} from '../../../../../context/salesman';
import InternalTemplate from '../../../../../components/templates/internal';
import {StackParamList} from '../../../../../navigators';
import {SpinnerModal} from '../../../../../components/modals';
import useToast from '../../../../../hooks';
import {ArrowLeftIcon, ArrowRightIcon} from '../../../../../components/icons';
import {IScheduleItem} from '../../../../../interfaces/dtos';
import {message} from '../../../../../utils/messages';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'SalesmanScheduleList'
>;

const buildHorary = (): number[] => {
  const hours = [];
  for (var i = 7; i < 19; i++) {
    hours.push(i);
  }
  return hours;
};

const SalesmanScheduleListScreen = ({navigation}: ScreenProps) => {
  const {schedule, fecthSchedule, setAppointment} = useSalesmanContext();
  const [horary] = useState(buildHorary());

  const [currentDate, setCurrentDate] = useState(new Date());

  const {showServerError} = useToast();

  const [isLoading, setIsLoading] = useState(false);

  const getSchedule = async () => {
    setIsLoading(true);
    const result = fecthSchedule();
    setIsLoading(false);
    if (!result) {
      showServerError();
    }
  };

  useEffect(() => {
    if (schedule == null) {
      getSchedule();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schedule]);

  const handleGoBack = () => {
    navigation.pop(1);
  };

  const formatHour = (hour: number) => {
    const meridiamLapse = hour > 12 ? 'PM' : 'AM';
    const meridiamTime = hour > 12 ? hour - 12 : hour;

    return `${meridiamTime} ${meridiamLapse}`;
  };

  const handlePressPreviousDay = () => {
    setCurrentDate(new Date(currentDate.setDate(currentDate.getDate() - 1)));
  };

  const handlePressNextDay = () => {
    setCurrentDate(new Date(currentDate.setDate(currentDate.getDate() + 1)));
  };

  const handlePressToday = () => {
    setCurrentDate(new Date());
  };

  const formatDate = (date: Date) => {
    const formatted = date.toLocaleString('es-VE', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    return formatted;
  };

  const handlePressAppointment = (appointment: IScheduleItem) => {
    setAppointment(appointment);
    navigation.navigate('SalesmanScheduleDetail');
  };

  const AppointmentsByHour = (props: {hour: number}) => {
    const {hour} = props;
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();

    const appointments = schedule
      ? schedule?.filter(appointment => {
          return (
            appointment.date.year === year &&
            appointment.date.month === month &&
            appointment.date.day === day &&
            appointment.date.hour === hour
          );
        })
      : [];

    return (
      <>
        {appointments?.map((appointment, index) => {
          return (
            <Pressable
              key={`appointment-${appointment.id}`}
              onPress={() => handlePressAppointment(appointment)}>
              <Box
                backgroundColor={'#0088FF'}
                padding={2}
                borderRadius={5}
                marginBottom={index === appointments.length - 1 ? 0 : 2}>
                <Heading
                  fontSize={'sm'}
                  color={'#FFFF'}
                  minWidth={'1/2'}
                  maxWidth={'80%'}>
                  {appointment.customer.name}
                </Heading>
              </Box>
            </Pressable>
          );
        })}
      </>
    );
  };

  return (
    <InternalTemplate
      title={'salesman-schedule-list-title'}
      contentPaddingX="0"
      fixed={true}
      backButton={{
        onPress: () => handleGoBack(),
        label: 'go-back',
        usage: 'external',
      }}>
      <SpinnerModal show={isLoading} />

      <VStack flex={1}>
        <HStack justifyContent={'space-around'} paddingLeft={0}>
          <Pressable onPress={handlePressToday}>
            <Box
              backgroundColor={'white'}
              borderColor={'#858597'}
              borderWidth={1}
              paddingX={5}
              paddingY={2}
              borderRadius={5}
              marginLeft={1}>
              <Text color={'#858597'}>
                {message('schedule-list-today-button')}
              </Text>
            </Box>
          </Pressable>
          <HStack
            flex={1}
            justifyContent={'space-between'}
            alignItems={'center'}
            paddingX={3}
            marginRight={5}>
            <Pressable onPress={handlePressPreviousDay}>
              <ArrowLeftIcon />
            </Pressable>
            <Heading fontSize={'md'} color={'#858597'} fontWeight={'400'}>
              {formatDate(currentDate)}
            </Heading>
            <Pressable onPress={handlePressNextDay}>
              <ArrowRightIcon />
            </Pressable>
          </HStack>
        </HStack>
        <ScrollView w={'100%'} flex={1} paddingTop={0} marginTop={5}>
          <VStack marginBottom={'80%'}>
            {horary.map(hour => {
              return (
                <HStack
                  key={`kye-${hour}`}
                  marginX={2}
                  marginY={1}
                  paddingBottom={2}
                  alignItems={'center'}
                  borderBottomWidth={1}
                  borderBottomColor={'#979797'}>
                  <Heading
                    fontSize={'sm'}
                    color={'#858597'}
                    fontWeight={'400'}
                    marginRight={1}
                    marginLeft={3}
                    width={50}>
                    {formatHour(hour)}
                  </Heading>
                  <VStack>
                    <AppointmentsByHour hour={hour} />
                  </VStack>
                </HStack>
              );
            })}
          </VStack>
        </ScrollView>
      </VStack>
    </InternalTemplate>
  );
};
export default SalesmanScheduleListScreen;
